module.exports = __webpack_public_path__ + "static/img/top_bg1.db17a24d.png";